import { Anchor, Card, Checkbox, CheckboxProps, Stack, Text } from 'ui';

import { PagesUrl } from '../../../utils';
import classes from './ShopToGiveTermsCheckboxCard.module.css';

interface ShopToGiveTermsCheckboxCardProps {
  checkboxFieldProps: CheckboxProps;
  /**
   * Text to append to the end of "Agree to Terms & Conditions"
   */
  labelAppendage?: string;
  hasError?: boolean;
}

const ShopToGiveTermsCheckboxCard = ({
  checkboxFieldProps,
  labelAppendage,
  hasError,
}: ShopToGiveTermsCheckboxCardProps) => {
  return (
    <Card className={classes.ShopToGiveTermsCheckboxCard} mod={{ error: hasError }}>
      <Stack gap="xs">
        <Checkbox
          label={
            <Text fz="sm" fw={600} c="gray.8">
              Agree to{' '}
              <Anchor
                href={`https://www.givebacks.com${PagesUrl.TERMS_of_SERVICE}`}
                target="_blank"
                c="cobalt"
                inherit
                fw={600}
              >
                Terms & Conditions
              </Anchor>
              {labelAppendage}
            </Text>
          }
          {...checkboxFieldProps}
          error={undefined}
        />

        <Text fz="8px">
          By registering an eligible card, you authorize your payment card network (i.e.,
          Mastercard, Visa, American Express) to monitor and share transaction data with the Rakuten
          Card Linked Offer Network, Inc. (RCLON), Rewards Network & Fidel API to qualify your
          transactions to earn rewards at participating local restaurants and retailers and provide
          you with offers that may be of interest to you. You also acknowledge and agree that RCLON,
          Rewards Network and Fidel API may share details of your qualifying transactions with
          Givebacks and participating local restaurants and retailers to support the program in
          accordance with the Givebacks Eligible Card Linked Offer{' '}
          <Anchor
            href={`https://www.givebacks.com${PagesUrl.TERMS_of_SERVICE}`}
            target="_blank"
            c="cobalt"
            inherit
          >
            Terms and Conditions
          </Anchor>{' '}
          and{' '}
          <Anchor
            href={`https://www.givebacks.com${PagesUrl.TERMS_of_SERVICE}`}
            target="_blank"
            c="cobalt"
            inherit
          >
            Privacy Policy
          </Anchor>
          . You can un-enroll an eligible card from the Givebacks program at any time by clicking
          Add/Edit eligible card under your Profile and selecting the eligible card you wish to
          remove. Most Visa, Mastercard and American Express payment cards are eligible for the
          program. When using an eligible debit card, please perform a signature debit transaction.
          Do not enter your PIN when using your eligible debit card to make a purchase if you want
          to earn cash back for your transaction.
        </Text>
      </Stack>
    </Card>
  );
};

export { ShopToGiveTermsCheckboxCard };
